import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Set title as early as possible
document.title = 'Crystal Dental Studio - Професійна стоматологія преміум-класу';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
